import { api } from '../index';

export const getDate = data => api.post('/dashboard', data);

export const getDateByMasterFile = data => api.post('/dashboard/filter', data);

export const exportCalendar = () => api.get('/dashboard/export-calendar');
